import React, { useState, useEffect, useMemo } from 'react'
import { Modal, Button, Steps, Tooltip, Row, Col, Select, Checkbox } from 'antd'
import CreditSummaryTable from './CreditSummaryTable'
import './CreditSummaryReview.css'
import { connect, useSelector } from 'react-redux';
import * as com from '../Common'
import * as st from "../State.js";
import * as act from '../Store/actions';
import { has, set } from 'lodash';

const mapDispatchToProps = (dispatch) => ({
    bulkAddBorrowerLoans: (t, who) => {
        dispatch(act.BulkAddBorrowerLoans(t, who));
    },
    changeBorrowerOwnedProperty: (t, i, v) => {
        dispatch(act.ChangeBorrowerOwnedProperty(t, i, v))
    },
    changeCoborrowerOwnedProperty: (t, i, v) => {
        dispatch(act.ChangeCoborrowerOwnedProperty(t, i, v))
    },
    changeMainProperty: (t, v) => {
        dispatch(act.ChangeMainProperty(t, v))
    },
})
const CreditSummaryReview = ({ 
    open,
    accounts = [],
    initialExcludeZeroBalance = true, 
    initialExcludeClosed = true,
    loading = false,
    defaultCheckedType,
    onCancel,
    onConfirm,
    bulkAddBorrowerLoans,
    changeBorrowerOwnedProperty,
    changeCoborrowerOwnedProperty,
    changeMainProperty,
    propertySource = 'all'
}) => {
    const PROPERTY_ACCOUNT_TYPES = [
        'Mortgage'
    ]
    const [selectedRows, setSelectedRows] = useState([])
    const [section3Rows, setSection3Rows] = useState([])
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [importComplete, setImportComplete] = useState(false)
    const [step, setStep] = useState(0)
    const [status, setStatus] = useState(['process', 'wait'])
    const [section3Info, setSection3Info] = useState({ count: 0, section3Selected: false, handleSection3Select: () => {} })
    const [selectedProperties, setSelectedProperties] = useState({})
    const handleSelectedRowsChange = (rows) => {
        setSelectedRows(rows)
        const section3Rows = rows.filter(row => PROPERTY_ACCOUNT_TYPES.includes(row.accountType))
        setSection3Rows(section3Rows)
    }
    const hasSection3Selected = selectedRows.some(row =>
        PROPERTY_ACCOUNT_TYPES.includes(row.accountType)
    )
    const hasSection2cSelected = selectedRows.some(row =>
        !PROPERTY_ACCOUNT_TYPES.includes(row.accountType)
    )
    const application = useSelector(state => state.application)

    const stripUnderscoreKeys = (obj) => {
        const newObj = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (key.startsWith('_')) {
                    newObj[key.slice(1)] = obj[key];
                } else {
                    newObj[key] = obj[key];
                }
            }
        }
        return newObj;
    }
    const loanTypeToSection3Label = {
        ConventionalRealEstateMortgage: "Conventional",
        FHARealEstateMortgage: "FHA",
        VeteransAdministrationRealEstateMortgage: "VA",
        FarmersHomeAdministrationFHMA: "USDA",
        HomeEquity: "Other",
        HomeEquityLineOfCredit: "Other"
    };
    const section3TypeOptions = [
        { value: "ConventionalRealEstateMortgage", label: "Conventional" },
        { value: "FHARealEstateMortgage", label: "FHA" },
        { value: "VeteransAdministrationRealEstateMortgage", label: "VA" },
        { value: "USDA-RD", label: "USDA" },
        { value: "Other", label: "Other" },
    ];
    const mapAccountStatusToPaidOff = (accountStatus) => {
        if (!accountStatus) return 'no';
        const status = accountStatus.toLowerCase();
        if (status === 'paid' || status === 'closed') {
          return 'yes';
        }
        return 'no';
    }
    const getLiabilities = (section3Rows) => {
        const convertToLoan = (row) => {
            let loan = new st.loan();
            const fieldMapping = {
                creditliabilityaccounttype: (row) =>
                    (row.accountType === 'Other' || row.accountType === 'CreditLine') ? 'Unknown' : row.accountType,
                name: 'creditorName',
                accountnumber: 'accountIdentifier',
                creditliabilityShownOwnershipType: 'ownership',
                creditloantype: 'loanType'
            };
            Object.entries(fieldMapping).forEach(([loanField, rowFieldOrFn]) => {
                if (typeof rowFieldOrFn === 'function') {
                    loan[loanField] = rowFieldOrFn(row)
                } else {
                    loan[loanField] = row[rowFieldOrFn]
                }
            })
            loan.key = Math.random().toString();
            loan.paidoffatclosing = mapAccountStatusToPaidOff(row.accountStatus);
            loan.remainingbalance = Math.floor(Number(row.unpaidBalanceAmount)).toString();
            loan.monthlypayment = Math.floor(Number(row.monthlyPaymentAmount)).toString();
            loan.dataSource = 'creditreport';
            loan.updateTime = new Date().toISOString();
            loan.loanType = row.loanType;
            // 计算creditloantype
            const section3Label = loanTypeToSection3Label[row.loanType];
            let creditloantype = 'Other';
            if (section3Label) {
                const found = section3TypeOptions.find(opt => opt.label === section3Label);
                if (found) creditloantype = found.value;
            }
            loan.creditloantype = creditloantype;
            return loan;
        };
        const converted = (section3Rows || [])
            .map(convertToLoan)
            .map((loan) => ({
                ...loan,
                linkedProperty: loan.linkedProperty || '',
            }));
    
        const stripped = converted.map(stripUnderscoreKeys);
        return stripped.filter(
            loan =>
                loan.creditliabilityaccounttype === "Mortgage" &&
                loan.name !== '' &&
                loan.accountnumber !== ''
        );
    };
    const [LiabilitiesList, setLiabilitiesList] = useState(getLiabilities(section3Rows));
    useEffect(() => {
        setLiabilitiesList(getLiabilities(section3Rows));
    }, [section3Rows]);
    const getLinkIcon = (linked) => {
        return linked ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <g clip-path="url(#clip0_1003_20881)">
                    <path d="M6.13037 8.25H12.1304V9.75H6.13037V8.25ZM15.2054 9H16.6304C16.6304 6.93 14.9504 5.25 12.8804 5.25H9.88037V6.675H12.8804C14.1629 6.675 15.2054 7.7175 15.2054 9ZM3.05537 9C3.05537 7.7175 4.09787 6.675 5.38037 6.675H8.38037V5.25H5.38037C3.31037 5.25 1.63037 6.93 1.63037 9C1.63037 11.07 3.31037 12.75 5.38037 12.75H8.38037V11.325H5.38037C4.09787 11.325 3.05537 10.2825 3.05537 9Z" fill="#325CEB"/>
                    <path d="M11.1304 12.5L12.6304 14L15.6304 11" stroke="#325CEB" stroke-width="1.5" stroke-linecap="square"/>
                </g>
                <defs>
                    <clipPath id="clip0_1003_20881">
                        <rect width="18" height="18" fill="white" transform="translate(0.130371)"/>
                    </clipPath>
                </defs>
            </svg>
        ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <g clip-path="url(#clip0_1003_3557)">
                    <path d="M12.8805 5.25H9.88049V6.675H12.8805C14.163 6.675 15.2055 7.7175 15.2055 9C15.2055 10.0725 14.4705 10.9725 13.473 11.235L14.568 12.33C15.7905 11.7075 16.6305 10.4625 16.6305 9C16.6305 6.93 14.9505 5.25 12.8805 5.25ZM12.1305 8.25H10.488L11.988 9.75H12.1305V8.25ZM1.63049 3.2025L3.96299 5.535C3.27389 5.81538 2.68396 6.29475 2.26851 6.91191C1.85306 7.52907 1.63094 8.25603 1.63049 9C1.63049 11.07 3.31049 12.75 5.38049 12.75H8.38049V11.325H5.38049C4.09799 11.325 3.05549 10.2825 3.05549 9C3.05549 7.8075 3.96299 6.825 5.12549 6.6975L6.67799 8.25H6.13049V9.75H8.17799L9.88049 11.4525V12.75H11.178L14.1855 15.75L15.1305 14.805L2.58299 2.25L1.63049 3.2025Z" fill="#CB8600"/>
                </g>
                <defs>
                    <clipPath id="clip0_1003_3557">
                        <rect width="18" height="18" fill="white" transform="translate(0.130493)"/>
                    </clipPath>
                </defs>
            </svg>
        )
    }
    const transparentLinkIcon = (linked) => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                <g clip-path="url(#clip0_1297_25269)">
                    <path d="M6.13086 8.25H12.1309V9.75H6.13086V8.25ZM15.2059 9H16.6309C16.6309 6.93 14.9509 5.25 12.8809 5.25H9.88086V6.675H12.8809C14.1634 6.675 15.2059 7.7175 15.2059 9ZM3.05586 9C3.05586 7.7175 4.09836 6.675 5.38086 6.675H8.38086V5.25H5.38086C3.31086 5.25 1.63086 6.93 1.63086 9C1.63086 11.07 3.31086 12.75 5.38086 12.75H8.38086V11.325H5.38086C4.09836 11.325 3.05586 10.2825 3.05586 9Z" fill="white"/>
                    <path d="M11.1309 12.5L12.6309 14L15.6309 11" stroke="white" stroke-width="1.5" stroke-linecap="square"/>
                </g>
                <defs>
                    <clipPath id="clip0_1297_25269">
                        <rect width="18" height="18" fill="white" transform="translate(0.130859)"/>
                    </clipPath>
                </defs>
            </svg>
        )
    }
    const getProperties = (application, currentView) => {
        if (currentView === 'all') {
            const borrowerProps = getProperties(application, 'borrower').map(p => ({ ...p, who: 'borrower' }));
            const coborrowerProps = getProperties(application, 'coborrower').map(p => ({ ...p, who: 'coborrower' }));
            // 交错合并
            const maxLength = Math.max(borrowerProps.length, coborrowerProps.length);
            const result = [];
            for (let i = 0; i < maxLength; i++) {
                if (borrowerProps[i]) result.push(borrowerProps[i]);
                if (coborrowerProps[i]) result.push(coborrowerProps[i]);
            }
            return result;
        }
        const isPurchase = application.property.purpose === "purchase"
        let properties = []
        const getSection = (index) => {
            if (index === 0) return '3a'
            if (index === 1) return '3b'
            if (index === 2) return '3c'
            return `Extra ${index - 2}`
        }
        const getSectionDescription = (index) => {
            if (index === 0) return "Section 3a. Property you own"
            if (index === 1) return "Section 3b. Additional Property"
            if (index === 2) return "Section 3c. Additional Property"
            return `Extra Property ${index - 2}`
        }
    
        if (!isPurchase) {
            properties.push({
                name: `${application[currentView].firstname} ${application[currentView].lastname}`,
                address: application.property.address,
                shortaddress: application.property.address.split(',')[0],
                state: application.property.state,
                county: application.property.county,
                zipcode: application.property.zipcode,
                propertyValue: application.property.appraisal,
                insurancemaintenancetaxes: application.property.insurancemaintenancetaxes,
                section: getSection(0),
                sectionDescription: getSectionDescription(0),
                status: application.property.status,
                propertytype: application.property.propertytype,
                occupancy: application.property.occupancy,
                loans: application.property.loans && application.property.loans.length > 0 
                ? application.property.loans 
                : [],
                who: currentView
            })
    
            application[currentView].ownedproperties.forEach((property, index) => {
                properties.push({
                    name: `${application[currentView].firstname} ${application[currentView].lastname}`,
                    address: property.address,
                    shortaddress: property.address.split(',')[0],
                    state: property.state,
                    county: property.county,
                    zipcode: property.zipcode,
                    propertyValue: property.marketvalue,
                    insurancemaintenancetaxes: property.insurancemaintenancetaxes,
                    section: getSection(index + 1),
                    sectionDescription: getSectionDescription(index + 1),
                    status: property.status,
                    propertytype: property.propertytype,
                    occupancy: property.occupancy,
                    loans: property.loans && property.loans.length > 0 
                    ? property.loans 
                    : [],
                    who: currentView
                })
            })
        } else {
            application[currentView].ownedproperties.forEach((property, index) => {
                properties.push({
                    name: `${application[currentView].firstname} ${application[currentView].lastname}`,
                    address: property.address,
                    shortaddress: property.address.split(',')[0],
                    state: property.state,
                    county: property.county,
                    zipcode: property.zipcode,
                    propertyValue: property.marketvalue,
                    insurancemaintenancetaxes: property.insurancemaintenancetaxes,
                    section: getSection(index),
                    sectionDescription: getSectionDescription(index),
                    status: property.status,
                    propertytype: property.propertytype,
                    occupancy: property.occupancy,
                    loans: property.loans && property.loans.length > 0 
                    ? property.loans 
                    : [],
                    who: currentView
                })
            })
        }
    
        return properties.filter(property => property.address !== "").map(p => ({ ...p, who: currentView }));
    }
    const SingleFamilyIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
            <path d="M2.85471 7.00023H1.53847L7.46154 1.07715L13.3846 7.00023H12.0684" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.85471 7.00023V11.6071C2.85471 11.9562 2.99338 12.2909 3.24022 12.5378C3.48707 12.7846 3.82186 12.9233 4.17095 12.9233H10.7521C11.1012 12.9233 11.436 12.7846 11.6829 12.5378C11.9297 12.2909 12.0684 11.9562 12.0684 11.6071V7.00023" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.14531 7.00023H8.77778V9.6327H6.14531V7.00023Z" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )    
    const TownhouseIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M5.70367 12.3847V1.61548L12.8333 7.96656" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.1852 7.59848C12.1852 8.69535 12.1852 10.231 12.1852 11.1882C12.1852 12.1455 11.321 12.3848 10.8889 12.3848C8.51235 12.3848 3.50001 12.3848 2.46297 12.3848C1.42593 12.3848 1.16667 11.5871 1.16667 11.1882V5.20532H5.37963" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
    const MultiFamilyIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
            <path d="M10.7692 1.15381L12.3846 5.4615" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.23077 1.15381L1.61539 5.4615" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 5.46143L7 10.846" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.23077 8.15381H10.7692" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.69231 5.86182V9.89259C2.69231 10.219 2.82198 10.5321 3.05279 10.7629C3.2836 10.9937 3.59666 11.1234 3.92308 11.1234H10.0769C10.4033 11.1234 10.7164 10.9937 10.9472 10.7629C11.178 10.5321 11.3077 10.219 11.3077 9.89259V5.86182" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.61539 5.46143L12.3846 5.46142" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.23077 1.15381H10.7692" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
    const CondoIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M3.56114 7.67627H5.58037V11.0417H3.56114V7.67627Z" stroke="#586570" stroke-width="1.07692" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.15819 1.1582H10.9355" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.15819 6.09399H10.9355" stroke="#586570" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.70137 1.70142V9.85863C1.70137 10.4534 2.18353 10.9356 2.77829 10.9356H9.31541C9.91017 10.9356 10.3923 10.4534 10.3923 9.85864V1.70142" stroke="#586570" stroke-width="1.07692" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
    const getPropertyTypeTag = (propertyType) => {
        const propertyTypeOptions = {
            'singlefamily': {
                icon: <SingleFamilyIcon />,
                label: 'Single family'
            },
            'singlefamilyattached': {
                icon: <SingleFamilyIcon />,
                label: 'Single family'
            },
            'townhouse': {
                icon: <TownhouseIcon />,
                label: 'Townhouse'
            },
            'singlefamilydetached': {
                icon: <TownhouseIcon />,
                label: 'Townhouse'
            },
            'twotofour': {
                icon: <MultiFamilyIcon />,
                label: 'Multi-family'
            },
            'twotofourfamily': {
                icon: <MultiFamilyIcon />,
                label: 'Multi-family'
            },
            'condominium': {
                icon: <CondoIcon />,
                label: 'Condo'
            }
        }
    
        const option = propertyTypeOptions[propertyType]
        if (!option) return null
    
        return (
            <div className="property-type-tag">
                {option.icon}
                <span className="property-type-label">{option.label}</span>
            </div>
        )
    }
    const occupancyOptions = [
        { value: "principal", label: "Primary Residence" },
        { value: "secondhome", label: "Second Home" },
        { value: "investment", label: "Investment" },
        application.property.purpose !== "purchase" ?
            { value: "fhasecond", label: "FHA Secondary Residence" }
            : { value: "other", label: "Other" },
    ]
    const statusOptions = [
        { value: "sold", label: "Sold" },
        { value: "pending", label: "Pending sale" },
        { value: "retained", label: "Retained" },
    ]
    const getOccupancyLabel = (value) => {
        const option = occupancyOptions.find(opt => opt.value === value)
        return option ? option.label : value
    }
    const getStatusLabel = (value) => {
        const option = statusOptions.find(opt => opt.value === value)
        return option ? option.label : value
    }
    const isChecked = (property, liabilityIndex) => {
        const arr = selectedProperties[liabilityIndex] || [];
        return arr.includes(property.address);
    };
    const isDisabled = (property, liabilityIndex) => {
        const arr = selectedProperties[liabilityIndex] || [];
        return arr.some(addr => {
            const p = properties.find(prop => prop.address === addr);
            return p && p.name === property.name && p.address !== property.address;
        });
    };
    const handlePropertyCheck = (property, liabilityIndex) => {
        const arr = selectedProperties[liabilityIndex] || [];
        if (arr.includes(property.address)) {
            setSelectedProperties({
                ...selectedProperties,
                [liabilityIndex]: arr.filter(addr => addr !== property.address)
            });
        } else {
            // 先移除同 borrower/coborrower 的已选 property，再添加当前 property
            const filtered = arr.filter(addr => {
                const p = properties.find(prop => prop.address === addr);
                return p && p.name !== property.name;
            });
            setSelectedProperties({
                ...selectedProperties,
                [liabilityIndex]: [...filtered, property.address]
            });
        }
    };
    const PropertyOption = ({ data, checked, disabled, onChange }) => {
        const isPropertyIncomplete = () => {
            const requiredFields = [
                'address',
                'insurancemaintenancetaxes',
                'status',
                'propertytype',
                'occupancy'
            ]
            return requiredFields.some(field => {
                const value = data[field]
                return value === '' || value === null || value === undefined
            })
        }
        return (
            <div className="property-option" style={{ display: 'flex', alignItems: 'flex-start' }}>
                <Checkbox checked={checked} onChange={onChange} style={{ marginRight: 8 }} />
                <div style={{ flex: 1 }}>
                    <div className="property-top">
                        <div className="property-title">{data.address}</div>
                        <div className="property-price">${data.propertyValue ? com.commaize(data.propertyValue) : '-'}</div>
                    </div>
                    <div className="property-middle">
                        <div>{data.name} - {data.sectionDescription}</div>
                        {isPropertyIncomplete() && (
                            <div className="property-incomplete">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <rect width="18" height="18" rx="9" fill="#CB8600"/>
                                    <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                                    <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
                                </svg>
                                <div>Incomplete</div>
                            </div>
                        )}
                    </div>
                    <div className="property-bottom">
                        <div className='property-tag-list'>
                            {getPropertyTypeTag(data.propertytype)}
                            <div className='property-occupancy-tag'>{getOccupancyLabel(data.occupancy)}</div>
                        </div>
                        <div className='property-status'>{getStatusLabel(data.status)}</div>
                    </div>
                </div>
            </div>
        )
    }
    const properties = getProperties(application, propertySource)
    const getDisabledMap = () => {
        const nameToSelected = {}
        Object.values(selectedProperties).forEach(addrArr => {
            (Array.isArray(addrArr) ? addrArr : [addrArr]).forEach(addr => {
                const p = properties.find(prop => prop.address === addr)
                if (p) nameToSelected[p.name] = addr
            })
        })
        const disabledMap = {}
        properties.forEach(prop => {
            if (
                nameToSelected[prop.name] &&
                nameToSelected[prop.name] !== prop.address
            ) {
                disabledMap[prop.address] = true
            }
        })
        return disabledMap
    }
    const disabledMap = getDisabledMap();
    const propertyOptions = properties.map(property => ({
        value: property.address,
        label: (liabilityIndex) => <PropertyOption data={property} checked={isChecked(property, liabilityIndex)} disabled={isDisabled(property, liabilityIndex)} onChange={(e) => handlePropertyCheck(property, liabilityIndex)} />,
        displayLabel: property.address,
        who: property.who,
        section: property.section,
        key: `${property.who}-${property.section}`
    }));
    const handleSelectChange = (liabilityIndex, selectedOptions) => {
        // selectedOptions 是 [{ value, ... }, ...]
        // 只保留每个 name（borrower/coborrower）最新选中的 property
        const uniqueByName = [];
        const seenNames = new Set();
        for (let i = selectedOptions.length - 1; i >= 0; i--) {
            const property = properties.find(p => p.address === selectedOptions[i].value);
            if (property && !seenNames.has(property.name)) {
                uniqueByName.unshift(selectedOptions[i]);
                seenNames.add(property.name);
            }
        }
        setSelectedProperties(prev => ({
            ...prev,
            [liabilityIndex]: uniqueByName.map(opt => opt.value)
        }));

        // 设置LiabilitiesList的linkedProperty为选中的property的`${who}-${section}`数组
        setLiabilitiesList(prev => {
            const newList = [...prev]
            if (newList[liabilityIndex]) {
                const linkedSections = uniqueByName
                    .map(opt => {
                        const property = properties.find(p => p.address === opt.value)
                        return property ? `${property.who}-${property.section}` : undefined
                    })
                    .filter(Boolean)
                newList[liabilityIndex].linkedProperty = linkedSections
            }
            return newList
        })
    }
    const linkConfirm = () => {
        const selectedKeys = LiabilitiesList.filter(l => l.linkedProperty).map(l => l.key);
        const isPurchase = application.property.purpose === "purchase";

        // // 先清理所有 properties 中的选中项
        // if (!isPurchase) {
        //     // 清理主要房产的 loans
        //     const mainPropertyLoans = application.property.loans || [];
        //     const filteredMainLoans = mainPropertyLoans.filter(loan => !selectedKeys.includes(loan.key));
        //     changeMainProperty(filteredMainLoans, "loans");
        // }

        // // 清理其他房产的 loans
        // const ownedProperties = application[currentView].ownedproperties;
        // ownedProperties.forEach((property, index) => {
        //     const currentLoans = property.loans || [];
        //     const filteredLoans = currentLoans.filter(loan => !selectedKeys.includes(loan.key));
        //     if (currentView === "borrower") {
        //         changeBorrowerOwnedProperty(filteredLoans, index, "loans");
        //     } else if (currentView === "coborrower") {
        //         changeCoborrowerOwnedProperty(filteredLoans, index, "loans");
        //     }
        // });
        const liabilitiesBySectionAndWho = {}; // { who: { section: [liabilities] } }
        LiabilitiesList.forEach((liability) => {
            if (!liability.linkedProperty) return;
            const linkedArr = Array.isArray(liability.linkedProperty) ? liability.linkedProperty : [liability.linkedProperty];
            linkedArr.forEach(linked => {
                if (!linked) return;
                const [who, section] = linked.split('-');
                if (!who || !section) return;
                if (!liabilitiesBySectionAndWho[who]) liabilitiesBySectionAndWho[who] = {};
                if (!liabilitiesBySectionAndWho[who][section]) liabilitiesBySectionAndWho[who][section] = [];
                const { linkedProperty, ...liabilityWithoutLinked } = liability;
                liabilitiesBySectionAndWho[who][section].push({ ...liabilityWithoutLinked });
            });
        });
        // 遍历每个 property section 添加新的 liabilities
        Object.entries(liabilitiesBySectionAndWho).forEach(([who, sectionMap]) => {
            Object.entries(sectionMap).forEach(([section, liabilities]) => {
                let propertyIndex;
                switch (section) {
                    case '3a': propertyIndex = 0; break;
                    case '3b': propertyIndex = application.property.purpose === 'purchase' ? 1 : 0; break;
                    case '3c': propertyIndex = application.property.purpose === 'purchase' ? 2 : 1; break;
                    default:
                        if (section.startsWith('Extra ')) {
                            const extraNum = parseInt(section.split(' ')[1]);
                            propertyIndex = application.property.purpose === 'purchase'
                                ? (2 + extraNum)
                                : (1 + extraNum);
                        }
                }
                if (section === '3a' && application.property.purpose !== 'purchase') {
                    const currentLoans = application.property.loans || [];
                    const newLoans = [...currentLoans, ...liabilities.map(l => ({
                        ...l,
                        dataSource: 'creditreport',
                        updateTime: new Date().toISOString()
                    }))];
                    console.log(newLoans)
                    changeMainProperty(newLoans, 'loans');
                } else {
                    const currentProperties = application[who].ownedproperties;
                    const currentProperty = currentProperties[propertyIndex] || {};
                    const currentLoans = currentProperty.loans || [];
                    const newLoans = [...currentLoans, ...liabilities.map(l => ({
                        ...l,
                        dataSource: 'creditreport',
                        updateTime: new Date().toISOString()
                    }))];
                    if (who === 'borrower') {
                        changeBorrowerOwnedProperty(newLoans, propertyIndex, 'loans');
                    } else if (who === 'coborrower') {
                        changeCoborrowerOwnedProperty(newLoans, propertyIndex, 'loans');
                    }
                }
            });
        });
    }
    const isLiabilityIncomplete = (liability) => {
        // 检查所有必填字段
        const requiredFields = [
            'creditliabilityaccounttype',
            'name',
            'accountnumber',
            'remainingbalance',
            'monthlypayment',
            'creditliabilityShownOwnershipType'
        ]
        
        return requiredFields.some(field => {
            const value = liability[field]
            return value === '' || value === null || value === undefined || value === '-'
        })
    }
    const handleConfirm = () => {
        if (hasSection3Selected && step === 0) {
            stepChange(step + 1)
        } else {
            stepChange(0)
            onCancel()
            setConfirmOpen(true)
        }
    }
    const modalCancel = () => {
        setConfirmOpen(false)
        setImportComplete(false)
    }
    const modalConfirm = (link) => {
        setConfirmOpen(false)
        setImportComplete(false)
        onConfirm(link)
    }
    const confirmImport = () => {
        // 区分 Section2c 和 Section3
        const section2cRows = selectedRows.filter(
            row => !PROPERTY_ACCOUNT_TYPES.includes(row.accountType)
        );
        const section3Rows = selectedRows.filter(
            row => PROPERTY_ACCOUNT_TYPES.includes(row.accountType)
        );

        // Section2c 走原有逻辑
        if (section2cRows.length > 0) {
            const convertToLoan = (row) => {
                let loan = new st.loan()
                const fieldMapping = {
                    creditliabilityaccounttype: (row) =>
                        (row.accountType === 'Other' || row.accountType === 'CreditLine') ? 'Unknown' : row.accountType,
                    name: 'creditorName',
                    accountnumber: 'accountIdentifier',
                    creditliabilityShownOwnershipType: 'ownership',
                    creditloantype: 'loanType'
                }
                Object.entries(fieldMapping).forEach(([loanField, rowFieldOrFn]) => {
                    if (typeof rowFieldOrFn === 'function') {
                        loan[loanField] = rowFieldOrFn(row)
                    } else {
                        loan[loanField] = row[rowFieldOrFn]
                    }
                })
                loan.key = Math.random().toString()
                loan.paidoffatclosing = mapAccountStatusToPaidOff(row.accountStatus)
                loan.remainingbalance = Math.floor(Number(row.unpaidBalanceAmount)).toString()
                loan.monthlypayment = Math.floor(Number(row.monthlyPaymentAmount)).toString()
                loan.dataSource = 'creditreport'
                loan.updateTime = new Date().toISOString()
                return loan
            }
            const convertedLoans = section2cRows.map(convertToLoan)
            bulkAddBorrowerLoans(convertedLoans, 'borrower')
        }
    
        if (section3Rows.length > 0) {
            linkConfirm()
        }
        setSelectedProperties({})
        setImportComplete(true)
    };
    const stepChange = (value) => {
        // if (value === 1 && (frequency === "" || frequency === undefined || !selectFile || selectFile === '')) {
        //     return
        // }
        const newStatus = status.map((s, index) =>
            index === value ? 'process' : index === 0 ? 'finish' : s
        )
        setStatus(newStatus)
        setStep(value)
    }
    const getStepIcon = (index) => {
        if (status[index] === 'finish') {
            return <img src="/images/income-step-success.svg" />
        }
        return null
    }
    const isAnyPropertyUnselected = step === 1 && LiabilitiesList.some((liability, idx) => !selectedProperties[idx] || selectedProperties[idx].length === 0);
    const isImportDisabled = selectedRows.length === 0 || isAnyPropertyUnselected;
    const footer = [
        <Button type='link' className='credit-summary-review-modal-footer-back' onClick={() => {
            if (step === 0) {
                onCancel()
            }
            stepChange(0)
        }}>
            {step === 0 ? 'Back to credit summary' : 'Back to liability selection'}
        </Button>,
        <div className='credit-summary-review-modal-footer-confirm'>
            <Button
                type='primary'
                disabled={isImportDisabled}
                className='credit-summary-review-modal-footer-confirm-button'
                onClick={handleConfirm}
            >
                {hasSection3Selected && step === 0 ? 'Next' : 'Import to 1003'}
            </Button>
        </div>
    ]
    const confirmFooter = [
        <Button type='link' className='credit-summary-confirm-modal-back' onClick={() => setConfirmOpen(false)}>Cancel</Button>,
        <Button type='primary' className='credit-summary-confirm-modal-import' onClick={confirmImport}>Yes, import to 1003</Button>
    ]
    // Section confirm modal dynamic text
    let confirmSectionText = '';
    let confirmSectionReplaceText = '';
    if (hasSection2cSelected && hasSection3Selected) {
        confirmSectionText = 'Section 2c and Section 3';
        confirmSectionReplaceText = 'those sections';
    } else if (hasSection2cSelected) {
        confirmSectionText = 'Section 2c';
        confirmSectionReplaceText = 'this section';
    } else if (hasSection3Selected) {
        confirmSectionText = 'Section 3';
        confirmSectionReplaceText = 'this section';
    }
    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;
        return (
            <span
                style={{
                    marginRight: 4,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 20,
                    backgroundColor: '#EAEFFD',
                    borderRadius: 8,
                    height: 34,
                    padding: '0px 16px 0px 12px',
                    fontSize: 16,
                    fontFamily: 'Inter',
                    color: '#325CEB',
                    fontWeight: 500,
                }}
            >
                {label}
                {closable && (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={onClose}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <rect x="0.515625" y="1.94482" width="2.04263" height="16.3411" transform="rotate(-45 0.515625 1.94482)" fill="#325CEB"/>
                            <rect x="12.0703" y="0.500488" width="2.04263" height="16.3411" transform="rotate(45 12.0703 0.500488)" fill="#325CEB"/>
                        </svg>
                    </span>
                )}
            </span>
        );
    };
    const handleClear = (liabilityIndex) => {
        setSelectedProperties(prev => ({
            ...prev,
            [liabilityIndex]: []
        }));
        setLiabilitiesList(prev => {
            const newList = [...prev];
            if (newList[liabilityIndex]) {
                newList[liabilityIndex].linkedProperty = '';
            }
            return newList;
        });
    };
    return (
        <>
            <Modal
                className='credit-summary-review-modal'
                maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
                maskClosable={false}
                width={974}
                open={open}
                centered
                destroyOnClose
                title="Review"
                onCancel={() => {
                    onCancel()
                    stepChange(0)
                }}
                footer={footer}
            >
                <div className='credit-summary-review-modal-content'>
                    {
                        hasSection3Selected && (
                            <div className='credit-summary-steps-wrapper'>
                                <Steps
                                    className='credit-summary-steps'
                                    size="small"
                                    current={step}
                                    onChange={stepChange}
                                    items={[
                                        {
                                            title: 'Select liabilities',
                                            icon: getStepIcon(0),
                                        },
                                        {
                                            title: 'Match mortgage to properties',
                                            icon: getStepIcon(1),
                                        }
                                    ]}
                                />
                            </div>
                        )
                    }
                    {
                        step === 0 && (
                            <div className='credit-summary-review-modal-content-title'>
                                Review the updated liabilities from your credit report or check the original data in 1003 
                                <span> <span className='link-text' onClick={() => {modalConfirm('#2c')}}>Section 2c.</span> {hasSection3Selected && <span>& <span className='link-text' onClick={() => {modalConfirm('#3a')}}>Section3.</span></span>}</span>
                            </div>
                        )
                    }
                    <div style={step === 0 ? { paddingRight: 50 } : {}} className='credit-summary-review-modal-content'>
                        {
                            step === 0 && defaultCheckedType === 'section2c' && section3Info.count > 0 && (
                                <div style={{marginRight: 0}} className='credit-summary-review-warning-card'>
                                    <div className='credit-summary-review-warning-icon'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34" fill="none">
                                            <path d="M15.5871 4.18709C16.757 2.27339 19.5365 2.27339 20.7063 4.18709L30.9447 20.9353C32.1668 22.9343 30.7281 25.5 28.3851 25.5H7.90836C5.56537 25.5 4.1267 22.9343 5.34874 20.9353L15.5871 4.18709Z" fill="#CB8600"/>
                                            <path d="M19.9104 7L19.6104 18.1768H16.6831L16.3922 7H19.9104ZM18.1467 23C17.5952 23 17.1225 22.8351 16.7285 22.5053C16.3407 22.1755 16.1467 21.7736 16.1467 21.2995C16.1467 20.8357 16.3407 20.439 16.7285 20.1092C17.1225 19.7794 17.5952 19.6145 18.1467 19.6145C18.6861 19.6145 19.1528 19.7794 19.5467 20.1092C19.9467 20.439 20.1467 20.8357 20.1467 21.2995C20.1467 21.6138 20.0528 21.8998 19.8649 22.1575C19.6831 22.4151 19.4407 22.6213 19.1376 22.7758C18.8407 22.9253 18.5104 23 18.1467 23Z" fill="white"/>
                                        </svg>
                                    </div>
                                    <div className='credit-summary-review-warning-content'>
                                        <div className='credit-summary-review-warning-content-title'>Additional mortgage loan found</div>
                                        <div className='credit-summary-review-warning-content-text'>
                                            {section3Info.count} mortgage loan{section3Info.count > 1 ? 's' : ''} also available under Section 3. Property you own- mortgage loans.
                                        </div>
                                        <div className='credit-summary-review-warning-content-button' onClick={() => {
                                            if (section3Info.handleSection3Select) section3Info.handleSection3Select(true);
                                        }}>Select to import</div>
                                    </div>
                                </div>
                            )
                        }
                        <div style={{ display: step === 0 ? 'block' : 'none'}}>
                            <CreditSummaryTable
                                type='grouped'
                                loading={loading}
                                accounts={accounts}
                                useCheckbox={true}
                                initialExcludeZeroBalance={initialExcludeZeroBalance}
                                initialExcludeClosed={initialExcludeClosed}
                                onSelectedRowsChange={handleSelectedRowsChange}
                                defaultCheckedType={defaultCheckedType}
                                onSection3InfoChange={setSection3Info}
                            />
                        </div>
                        <div style={{ display: step === 1 ? 'flex' : 'none'}} className='link-mortgage-content'>
                            <div className='link-mortgage-content-title'>Link mortgage liabilities to properties listed in Section 3.</div>
                            {
                                properties.length === 0 && (
                                    <div style={{marginRight: '46px'}} className='credit-summary-review-warning-card'>
                                        <div className='credit-summary-review-warning-icon'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="34" viewBox="0 0 37 34" fill="none">
                                                <path d="M15.5871 4.18709C16.757 2.27339 19.5365 2.27339 20.7063 4.18709L30.9447 20.9353C32.1668 22.9343 30.7281 25.5 28.3851 25.5H7.90836C5.56537 25.5 4.1267 22.9343 5.34874 20.9353L15.5871 4.18709Z" fill="#CB8600"/>
                                                <path d="M19.9104 7L19.6104 18.1768H16.6831L16.3922 7H19.9104ZM18.1467 23C17.5952 23 17.1225 22.8351 16.7285 22.5053C16.3407 22.1755 16.1467 21.7736 16.1467 21.2995C16.1467 20.8357 16.3407 20.439 16.7285 20.1092C17.1225 19.7794 17.5952 19.6145 18.1467 19.6145C18.6861 19.6145 19.1528 19.7794 19.5467 20.1092C19.9467 20.439 20.1467 20.8357 20.1467 21.2995C20.1467 21.6138 20.0528 21.8998 19.8649 22.1575C19.6831 22.4151 19.4407 22.6213 19.1376 22.7758C18.8407 22.9253 18.5104 23 18.1467 23Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <div className='credit-summary-review-warning-content'>
                                            <div className='credit-summary-review-warning-content-title'>No properties</div>
                                            <div className='credit-summary-review-warning-content-text'>No properties are currently listed in Section 3. Please add a property before linking this liability.</div>
                                            <div className='credit-summary-review-warning-content-button' onClick={() => {
                                                modalConfirm('#3a')
                                            }}>Add property in Section 3</div>
                                        </div>
                                    </div>
                                )
                            }
                            <div className='link-mortgage-list'>
                                {
                                    LiabilitiesList.map((liability, liabilityIndex) => {
                                        // const formattedText = liability.name.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                                        // 只根据 select 是否有值判断 Linked
                                        const isLinked = selectedProperties[liabilityIndex] && selectedProperties[liabilityIndex].length > 0
                                        return (
                                            <div className='link-mortgage-list-item'>
                                                <div className='link-mortgage-list-item-header'>
                                                    <div className='link-mortgage-item-title'>
                                                        <div className='link-mortgage-item-title-text'>
                                                            <span>{liability.name}</span>
                                                            {isLiabilityIncomplete(liability) && (
                                                                <div className="property-incomplete">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                        <rect width="18" height="18" rx="9" fill="#CB8600"/>
                                                                        <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                                                                        <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
                                                                    </svg>
                                                                    <div>Incomplete</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {isLinked ? (
                                                            <div 
                                                                className={`link-mortgage-item-title-link property-link linked`}
                                                            >
                                                                <span className="default-icon">{getLinkIcon(true)}</span>
                                                                <span className="hover-icon">{transparentLinkIcon(true)}</span>
                                                                Linked
                                                            </div>
                                                        ) : (
                                                            <div className={`link-mortgage-item-title-link property-link unlinked`}>
                                                                <span className="default-icon">{getLinkIcon(false)}</span>
                                                                <span className="hover-icon">{transparentLinkIcon(false)}</span>
                                                                Unlinked
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='link-mortgage-item-account-number'>Account number: {liability.accountnumber}</div>
                                                </div>
                                                <div className='link-mortgage-item-content'>
                                                    <Row gutter={[64, 24]}>
                                                        <Col md={6} span={24}>
                                                            <div className='link-mortgage-item-title'>Account type</div>
                                                            <div className='link-mortgage-item-value'>{liability.creditliabilityaccounttype}</div>
                                                        </Col>
                                                        <Col md={6} span={24}>
                                                            <div className='link-mortgage-item-title'>Company name</div>
                                                            <div className='link-mortgage-item-value'>{liability.name}</div>
                                                        </Col>
                                                        <Col md={6} span={24}>
                                                            <div className='link-mortgage-item-title'>Account number</div>
                                                            <div className='link-mortgage-item-value'>{liability.accountnumber}</div>
                                                        </Col>
                                                        <Col md={6} span={24}>
                                                            <div className='link-mortgage-item-title'>Unpaid balance</div>
                                                            <div className='link-mortgage-item-value'>${liability.remainingbalance ? com.commaize(liability.remainingbalance) : '-'}</div>
                                                        </Col>
                                                        <Col md={6} span={24}>
                                                            <div className='link-mortgage-item-title'>Mo. payment</div>
                                                            <div className='link-mortgage-item-value'>${liability.monthlypayment ? com.commaize(liability.monthlypayment) : '-'}</div>
                                                        </Col>
                                                        <Col md={6} span={24}>
                                                            <div className='link-mortgage-item-title'>Ownership</div>
                                                            <div className='link-mortgage-item-value'>{liability.creditliabilityShownOwnershipType === 'CoBorrower' ? 'Co-borrower' : liability.creditliabilityShownOwnershipType}</div>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: 32 }}>
                                                        <Col md={24} span={24}>
                                                            <div className='link-mortgage-item-title'>Select a property</div>
                                                            <div style={{ position: 'relative', width: '100%' }}>
                                                                <Select 
                                                                    mode="multiple"
                                                                    className='link-mortgage-item-select'
                                                                    style={{ width: '100%' }}
                                                                    listHeight={272}
                                                                    getPopupContainer={triggerNode => triggerNode.parentElement}
                                                                    placeholder={properties.length === 0 ? 'No properties are currently listed' : 'Select a property from section3'}
                                                                    options={propertyOptions.map(opt => ({...opt, label: opt.label(liabilityIndex)}))}
                                                                    value={selectedProperties[liabilityIndex] || []}
                                                                    labelInValue
                                                                    onChange={(options) => handleSelectChange(liabilityIndex, options)}
                                                                    optionLabelProp="displayLabel"
                                                                    suffixIcon={
                                                                        <div style={{ display: 'flex', justifyContent: 'center', width: 32, height: 32, paddingTop: 5 }}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                                                                                <rect width="1.98616" height="11.917" rx="0.99308" transform="matrix(0.712034 -0.702145 0.712034 0.702145 0.630554 8.52026)" fill="#222222"/>
                                                                                <rect width="1.98616" height="11.917" rx="0.99308" transform="matrix(0.712034 0.702145 -0.712034 0.702145 16.1869 7.12573)" fill="#222222"/>
                                                                            </svg>
                                                                        </div>
                                                                    }
                                                                    tagRender={tagRender}
                                                                />
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        right: 42,
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        height: 34,
                                                                        padding: '0px 10px 0px 4px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        color: '#325CEB',
                                                                        backgroundColor: '#FCFCFC',
                                                                        fontSize: 16,
                                                                        fontFamily: 'Inter',
                                                                        cursor: 'pointer',
                                                                        fontWeight: 500,
                                                                        userSelect: 'none',
                                                                        zIndex: 2
                                                                    }}
                                                                    onClick={() => handleClear(liabilityIndex)}
                                                                >
                                                                    Clear
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                className={importComplete ? 'credit-summary-review-complete-modal' : 'credit-summary-review-confirm-modal'}
                maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
                maskClosable={false}
                width={importComplete ? 568 : 410}
                open={confirmOpen}
                centered
                title={importComplete ? null : 'Confirm'}
                onCancel={modalCancel}
                footer={importComplete ? null : confirmFooter}
            >
                {
                    importComplete ? (
                        <div className='credit-summary-complete-content'>
                            <img src='/images/credit-import-complete.svg' />
                            <div className='credit-summary-complete-content-title'>Liabilities Successfully Imported</div>
                            <div className='credit-summary-complete-content-text'>
                                {`Liabilities have been successfully imported into 1003 ${confirmSectionText}. You can now review or update the imported data.`}
                            </div>
                            <div className='credit-summary-complete-content-button-group'>
                                <Button className='credit-summary-complete-back-button' onClick={modalCancel}>{defaultCheckedType === 'all' ? 'Stay in credit report' : 'Back to 1003'}</Button>
                                <Button type='primary' className='credit-summary-complete-continue-button' onClick={() => modalConfirm(hasSection3Selected && !hasSection2cSelected ? '#3a' : '#2c')}>
                                    Go to 1003
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.24408 15.5892C7.91864 15.2638 7.91864 14.7362 8.24408 14.4107L12.6548 9.99998L8.24408 5.58924C7.91864 5.2638 7.91864 4.73616 8.24408 4.41072C8.56951 4.08529 9.09715 4.08529 9.42259 4.41072L14.4226 9.41072C14.748 9.73616 14.748 10.2638 14.4226 10.5892L9.42259 15.5892C9.09715 15.9147 8.56951 15.9147 8.24408 15.5892Z" fill="white"/>
                                    </svg>
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className='credit-summary-confirm-text'>
                            <div>{`You're about to import liabilities from the selected credit report into 1003 ${confirmSectionText}. This action will remove and replace all previously entered liabilities in ${confirmSectionReplaceText}.`}</div>
                            <div>Would you like to proceed?</div>
                        </div>
                    )
                }
            </Modal>
        </>
    )
}

export default connect(null, mapDispatchToProps)(CreditSummaryReview)